import React from 'react';
import { useTheme } from '../ThemeContext';
import { useCheckout } from '../CheckoutContext';
import { useT } from '../i18n/useT';

const FixedEnrollButton = () => {
  const { isDark } = useTheme();
  const { startCheckout } = useCheckout();
  const t = useT();

  return (
    <div
      data-testid="fixed-enroll-button"
      style={{
        position: 'fixed',
        bottom: 36,
        right: 68,
        zIndex: 9998,
      }}
    >
      <div
        onClick={() => startCheckout('fixed_bottom')}
        style={{
          cursor: 'pointer',
          backgroundColor: 'rgba(10,10,15,0.9)',
          color: '#FFFFFF',
          padding: '14px 32px',
          fontSize: '15px',
          fontWeight: 'bold',
          fontFamily: '"Space Grotesk", sans-serif',
          textAlign: 'center',
          border: '1.5px solid rgba(255,255,255,0.4)',
          borderRadius: '4px',
          letterSpacing: '0.05em',
          backdropFilter: 'blur(8px)',
          transition: 'all 0.2s ease',
        }}
      >
        {t.fixedBtn}
      </div>
    </div>
  );
};

export default FixedEnrollButton;
